import ApiService from "@/core/services/api.service";
import { SET_ERROR } from "@/core/services/store/auth.module";
import { STATUS_CODE } from "@/core/config/constant";
// mutation types
export const GET_LIST_VOUCHER = "GetListVoucher";
export const SET_LIST_VOUCHER = "setListVoucher";
export const SET_SUCCESS = "SetSuccess";
export const GET_SUCCESSFUL = "listCost";
export const ADD_COST = "addCost";
export const SET_STATUS = "setStatus";
export const SET_ERROR_MESSAGE = "setErrorMessage";
export const GET_DETAIL_VOUCHER = "GetDetailVoucher";
export const SET_DETAIL_VOUCHER = "SetDetailVoucher";

const { SUCCESS, BAD_REQUEST } = STATUS_CODE;

const state = {
    errors: null,
    success: null,
    listVoucher: [],
    status: null,
    detailVoucher:{}
};

const getters = {
    ListVoucher(state) {
        return state.listVoucher;
    },
    getVoucherSuccessful(state) {
        return state.success;
    },
    detailVoucher(state){
        return state.detailVoucher
    }
};


const mutations = {
    [SET_LIST_VOUCHER](state, listVoucher) {
        state.listVoucher = listVoucher;
    },
    [SET_SUCCESS](state, code) {
        state.success = code;
    },
    [SET_STATUS](state, code) {
        state.status = code;
    },
    [SET_ERROR_MESSAGE](state, errors) {
        state.errors = errors
    },
    [SET_DETAIL_VOUCHER](state, detailVoucher) {
        state.detailVoucher = detailVoucher
    }

};


const actions = {
    async [GET_LIST_VOUCHER](context) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        try {
            const response = await ApiService.get(`voucher/list-voucher`)
            if (response.data.code == SUCCESS) {
                context.commit(SET_LIST_VOUCHER, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR_MESSAGE, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    },
    async [GET_DETAIL_VOUCHER](context,{id}) {
        context.commit(SET_STATUS, null)
        context.commit(SET_ERROR_MESSAGE, null)
        try {
            const response = await ApiService.get(`form/get-detail-voucher-custom/${id}`)
            if (response.data.code == SUCCESS) {
                context.commit(SET_DETAIL_VOUCHER, response.data.data);
                context.commit(SET_STATUS, response.data.code)
            }
            if (response.data.code == BAD_REQUEST) {
                context.commit(SET_STATUS, response.data.code)
                context.commit(SET_ERROR_MESSAGE, response.data.data)
            }
        } catch (e) {
            if (e.response.data.code == ERROR_SERVER) {
                context.commit(SET_ERROR_MESSAGE, e.response.data.message);
                throw e.response.data.message
            } else {
                throw e;
            }
        }
    },
}



export default {
    state,
    actions,
    mutations,
    getters
};
